/** Rspack turns the `new URL(..., import.meta.url)` form into its own chunk. */
export const createPreprocessWorker = (): Worker =>
  new Worker(new URL('./image-preprocess.worker.ts', import.meta.url), {type: 'module'});
